import React from "react";
import { Paper, Text } from "@mantine/core";
import {
  LeafletControlWrapper,
  LeafletControlWrapperProps,
} from "components/LeafletMap/Utils/LeafletControlWrapper";
import { MouseCoordinateValueDisplay } from "./MouseCoordinateValueDisplay";
import classes from "./MouseCoordinateControl.module.css";

type Props = {
  position: LeafletControlWrapperProps["position"];
};
/**
 * Displays current mouse position coordinates
 */
export const MouseCoordinateControl = ({ position }: Props) => (
  <LeafletControlWrapper position={position}>
    <Paper className={classes.control}>
      <Text size="xs" py={3} px={4} mr={4}>
        <MouseCoordinateValueDisplay />
      </Text>
    </Paper>
  </LeafletControlWrapper>
);
